import Typography from 'components/UI/Typography/Typography';

import { ReactComponent as ChartGrowIcon } from 'images/Icons/ChartGrow.svg';
import { ReactComponent as CheckMarkCircleIcon } from 'images/Icons/CheckMarkCircle.svg';
import { ReactComponent as CodeIcon } from 'images/Icons/Code.svg';
import { ReactComponent as DartTargetIcon } from 'images/Icons/DartTarget.svg';
import { ReactComponent as DocumentationIcon } from 'images/Icons/Documentation.svg';
import { ReactComponent as InfoChatIcon } from 'images/Icons/InfoChat.svg';
import { ReactComponent as PortfolioIcon } from 'images/Icons/Portfolio.svg';
import { ReactComponent as RocketIcon } from 'images/Icons/Rocket.svg';
import { ReactComponent as ShopIcon } from 'images/Icons/Shop.svg';
import { ReactComponent as WalletIcon } from 'images/Icons/Wallet.svg';
import { ReactComponent as WheelIcon } from 'images/Icons/Wheel.svg';

export const TABS = [
  {
    label: 'Progress',
    value: 'progress',
    Icon: DartTargetIcon,
  },
  {
    label: 'Rules',
    value: 'rules',
    Icon: InfoChatIcon,
  },
  {
    label: 'Terms and conditions',
    value: 'terms',
    Icon: DocumentationIcon,
  },
  {
    label: 'Rewards',
    value: 'rewards',
    Icon: WalletIcon,
  },
];

export const PERIOD_OPTIONS = [
  {
    label: 'Any month',
    value: 'any_month',
  },
  {
    label: '1 month',
    value: '1_month',
  },
  {
    label: '2 month',
    value: '2_months',
  },
  {
    label: '3 month',
    value: '3_months',
  },
];

export const BONUS_TASK_OPTION = {
  label: 'Bonus task',
  value: 'bonus_task',
};

export const KPI_KEYS = [
  'marketingKPI50',
  'marketingKPI100',
  'businessKPI50',
  'businessKPI75',
  'businessKPI100',
];

export const RULES = {
  howItWorks: [
    {
      title: 'Sign Up',
      description:
        'Register in the Rewards System and provide the necessary consents to participate — quick, easy, rewarding.',
      Icon: DartTargetIcon,
    },
    {
      title: 'Submit your marketing activities',
      description:
        'Complete a tailored set of marketing activities focused on promoting Evoplay games, tournaments, quest campaigns.',
      Icon: CheckMarkCircleIcon,
    },
    {
      title: 'Keep boosting your KPI',
      description:
        'Achieve your business targets by increasing your BETSUM by X% compared to the previous season (rolling 3-month period).',
      Icon: RocketIcon,
    },
    {
      title: 'Earn rewards to use it in shop',
      description:
        "As you complete activities and reach KPI milestones, you'll earn digital coins. Redeem them in our exclusive reward shop!",
      Icon: ShopIcon,
    },
  ],
  bonusOpportunity: [
    {
      title: 'Stay consistent and grow your $-KPI quarter by quarter',
      description: (
        <>
          Reach at{' '}
          <Typography element="span" color="blue" weight="semibold">
            least 50% of your target KPI
          </Typography>{' '}
          each season, and you’ll qualify for our{' '}
          <Typography element="span" color="blue" weight="semibold">
            grand annual raffle
          </Typography>{' '}
          — with a chance to win an unforgettable trip to{' '}
          <Typography element="span" color="blue" weight="semibold">
            Maldives or Dubai
          </Typography>{' '}
          for 2–5 people!*
        </>
      ),
      icon: '🎁',
    },
  ],
  bonusTasks: [
    {
      title: 'Activating balance increases',
      Icon: ChartGrowIcon,
    },
    {
      title: 'Launching or promoting free spins',
      Icon: WheelIcon,
    },
    {
      title: 'Adding Slotopia games to your portfolio',
      Icon: PortfolioIcon,
    },
    {
      title: 'Integrating Player Space',
      Icon: CodeIcon,
    },
  ],
};

export const SEASON_COLUMNS = [
  {
    id: 'activity',
    label: 'Activity name',
  },
  {
    id: 'reward',
    label: 'Reward',
  },
  {
    id: 'status',
    label: 'Status',
  },
  {
    id: 'accrued',
    label: 'Accrued',
  },
];
